module.exports = __webpack_public_path__ + "static/media/stats.e78c20f8.svg";